/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  ErrorLimited,
  GatewayTimeout,
  GetIncursions200Ok,
  InternalServerError,
  ServiceUnavailable,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    ErrorLimitedFromJSON,
    ErrorLimitedToJSON,
    GatewayTimeoutFromJSON,
    GatewayTimeoutToJSON,
    GetIncursions200OkFromJSON,
    GetIncursions200OkToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
} from '../models/index';

export interface GetIncursionsRequest {
    datasource?: GetIncursionsDatasourceEnum;
    ifNoneMatch?: string;
}

/**
 * 
 */
export class IncursionsApi extends runtime.BaseAPI {

    /**
     * Return a list of current incursions  ---  This route is cached for up to 300 seconds
     * List incursions
     */
    async getIncursionsRaw(requestParameters: GetIncursionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetIncursions200Ok>>> {
        const queryParameters: any = {};

        if (requestParameters['datasource'] != null) {
            queryParameters['datasource'] = requestParameters['datasource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['ifNoneMatch'] != null) {
            headerParameters['If-None-Match'] = String(requestParameters['ifNoneMatch']);
        }

        const response = await this.request({
            path: `/v1/incursions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetIncursions200OkFromJSON));
    }

    /**
     * Return a list of current incursions  ---  This route is cached for up to 300 seconds
     * List incursions
     */
    async getIncursions(requestParameters: GetIncursionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetIncursions200Ok>> {
        const response = await this.getIncursionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetIncursionsDatasourceEnum = {
    Tranquility: 'tranquility'
} as const;
export type GetIncursionsDatasourceEnum = typeof GetIncursionsDatasourceEnum[keyof typeof GetIncursionsDatasourceEnum];
